import React, { useState } from 'react';
import {
  Layout, Row, Col, Typography, Card, Form,
} from 'antd';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { ReactComponent as SiderCo3Logo } from '../../assets/co3-logo-dark-100.svg';
import RegistrationSteps from '../../components/steps/RegistrationSteps';
import RegisterAccount from '../../components/steps/RegisterAccount';
import FillCompanyData from '../../components/steps/FillCompanyData';
import { FlowType } from '../../types';
import { FormConfig } from '../../config/formConfig';

const InviteContent = styled(Layout.Content)`
  background: #e5e5e5;
  border-top-left-radius: 25px;
`;

const InviteSider = styled(Layout.Sider)`
  background: #fdfefe;
`;

const SetUpText = styled(Typography.Text)`
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  display: flex;
  align-items: center;
  text-align: center;
  text-transform: uppercase;

  color: #489ed7;
`;

const RegisterAccountCard = styled(Card)`
  background: #FFFFFF;
  border: 1px solid #FFFFFF;
  box-sizing: border-box;
  box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  width: 634px;
`;

const Registration = () => {
  const [traceId] = useState(Date.now());
  const { t } = useTranslation();
  const [step, setStep] = useState(0);
  const [createAccountForm] = Form.useForm();
  const [uuid, setUuid] = useState('');

  const setNextStep = () => {
    setStep(step + 1);
  };

  const stepView = (s) => {
    switch (s) {
      case 0:
        return (
          <>
            <RegisterAccountCard>
              <RegisterAccount
                form={createAccountForm}
                regionFormConfig={FormConfig.default}
                setStep={() => setNextStep()}
                setUuid={(e) => setUuid(e)}
                traceId={traceId}
              />
            </RegisterAccountCard>
          </>
        );
      case 1:
        return (
          <>
            <FillCompanyData
              uuid={uuid}
              regionFormConfig={FormConfig[createAccountForm.getFieldValue('region')]}
              password={createAccountForm.getFieldValue('password')}
              username={createAccountForm.getFieldValue('email')}
              flowType={FlowType.REGISTRATION}
              traceId={traceId}
            />
          </>
        );

      default:
        return (<></>);
    }
  };

  return (
    <>
      <Layout style={{ height: ' 110vh ' }}>
        <InviteSider width="30%" height="100%">
          <Row justify="space-between" style={{ width: '100%', marginBottom: '60px' }}>
            <Col span={24} />
          </Row>
          <Row style={{ width: '100%', margin: '0 auto', marginBottom: '60px' }} justify="center">
            <Col>
              <SiderCo3Logo />
            </Col>
          </Row>
          <Row justify="center" style={{ width: '100%', marginBottom: '14px' }}>
            <Col className="gutter-row">
              <SetUpText>{t('SET_UP_ACCOUNT_TEXT')}</SetUpText>
            </Col>
          </Row>
          <Row justify="center">
            <Col>
              <RegistrationSteps currentStep={step} />
            </Col>
          </Row>
        </InviteSider>
        <InviteContent>
          <Row justify="space-between" style={{ width: '100%', marginBottom: '100px' }}>
            <Col span={24} />
          </Row>
          <Row justify="center" style={{ marginBottom: '416px' }}>
            {stepView(step)}
          </Row>
        </InviteContent>
      </Layout>
    </>
  );
};

export default Registration;
